import { Icon, type IconType } from "./icon";

interface EmptyStateProps {
  title: string;
  description?: string;
  icon?: IconType;
  actions?: React.ReactNode;
}

export function EmptyState({
  title,
  description,
  icon,
  actions,
}: EmptyStateProps) {
  return (
    <div className="flex h-full flex-col items-center justify-center gap-2 p-6 text-center">
      {icon && (
        <div className="mb-2 rounded-xl bg-muted p-3 text-muted-foreground">
          <Icon icon={icon} className="size-6" />
        </div>
      )}
      <h2 className="text-lg font-semibold">{title}</h2>
      {description && (
        <p className="max-w-sm text-sm text-muted-foreground">{description}</p>
      )}
      {actions && <div className="mt-2">{actions}</div>}
    </div>
  );
}
